import styled from "react-emotion";

import { Button } from "bloomer";

const ActionButton = styled(Button)`
  background: white;
  color: #2f3241;
  border: 1px solid #1c2541;

  :hover {
    border: 1px solid #1c2541;
    color: white;
    background: #2f3241;
  }
`;

export default ActionButton;



// WEBPACK FOOTER //
// ./src/elements/Button.tsx